//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultLayout from '~/layouts/default.vue';
import PrimaryHeader from '~/components/headers/PrimaryHeader';

export default {
	components: {
		DefaultLayout,
		PrimaryHeader,
	},

	data() {
		return {
			tabs: [
				{
					name: 'Applications',
					href: '/candidates/applications',
				},
				{
					name: 'Viewed',
					href: '/candidates/viewed',
				},
				{
					name: 'Shortlist',
					href: '/candidates/shortlist',
				},
				{
					name: 'Interviews',
					href: '/candidates/interviews',
				},
				{
					name: 'Offers Made',
					href: '/candidates/offers-made',
				},
				{
					name: 'Prospect List',
					href: '/candidates/prospect-list',
				},
			],
		};
	},
};
